import React from 'react';
import logo from '../images/logo-short.png';

const SOCIALS = [
  {
    label: 'Instagram',
    href: 'https://instagram.com/aqmcs_',
    svg: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>,
  },
  {
    label: 'Facebook',
    href: 'https://facebook.com/aqmcs.india',
    svg: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 0H4C1.791 0 0 1.791 0 4v16c0 2.209 1.791 4 4 4h16c2.209 0 4-1.791 4-4V4c0-2.209-1.791-4-4-4zm-3 7h-1.5C14.672 7 14 7.672 14 8.5V10h3l-.5 3h-2.5v8h-3v-8H9v-3h2V8.5C11 6.015 12.515 4 15 4c1.036 0 2 .196 2 .196V7z"/></svg>,
  },
  {
    label: 'LinkedIn',
    href: 'https://linkedin.com/company/aqmcs',
    svg: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>,
  },
  {
    label: 'X (Twitter)',
    href: 'https://x.com/aqmcs',
    svg: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>,
  },
];

const SERVICE_LINKS = [
  { label: 'ZED Assessment',    page: 'Zed',      path: '/zed'      },
  { label: 'Food Safety Audit', page: 'Services', path: '/services' },
  { label: 'Third Party Audit', page: 'Services', path: '/services' },
  { label: 'ISO Certification', page: 'Services', path: '/services' },
  { label: 'Green Audit',       page: 'Services', path: '/services' },
];

const COMPANY_LINKS = [
  { label: 'Home',          page: 'Home',          path: '/'              },
  { label: 'Services',      page: 'Services',      path: '/services'      },
  { label: 'Accreditation', page: 'Accreditation', path: '/accreditation' },
  { label: 'Documents',     page: 'Documents',     path: '/documents'     },
  { label: 'About Us',      page: 'About',         path: '/about'         },
  { label: 'Contact Us',    page: 'Contact',       path: '/contact'       },
];

export default function Footer({ navigate }) {
  const go = (pageKey, e) => {
    e.preventDefault();
    navigate(pageKey);
  };

  return (
    <footer role="contentinfo">
      <div className="footer-inner">
        <div className="footer-top">

          {/* Brand */}
          <div className="footer-brand">
            <a
              className="logo-wrap"
              href="/"
              onClick={(e) => go('Home', e)}
              aria-label="Assure Quality — Home"
              style={{ marginBottom: '0.5rem' }}
            >
              <img src={logo} height="50" alt="Assure Quality Management Certification Services" />
              <div className="logo-name-block">
                <span className="logo-name"><em>Assure</em> Quality</span>
                <span className="logo-tagline">Management Certification Services</span>
              </div>
            </a>
            <p>
              Assure Quality Management Certification Services Private Limited provides expert services in ZED Assessment, Food Safety Audits, Tender Document Verification, Third Party Audits &amp; Management System Certification since 2006.
            </p>
            <div className="footer-socials">
              {SOCIALS.map(({ svg, label, href }) => (
                <a
                  key={label}
                  className="social-btn"
                  href={href}
                  aria-label={label}
                  title={label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {svg}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              {SERVICE_LINKS.map(({ label, page, path }) => (
                <li key={label}>
                  <a href={path} onClick={(e) => go(page, e)}>{label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              {COMPANY_LINKS.map(({ label, page, path }) => (
                <li key={label}>
                  <a href={path} onClick={(e) => go(page, e)}>{label}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li>
                <a
                  href="https://maps.google.com/?q=SCF+97+Sector+11+Panchkula"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-contact-item"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21c-4.418-4.418-7-8.015-7-11a7 7 0 1 1 14 0c0 2.985-2.582 6.582-7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>
                  SCF 97, 2nd Floor, Sector 11, Panchkula, Haryana 134113
                </a>
              </li>
              <li>
                <a href="tel:+919216183238" className="footer-contact-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.91a16 16 0 0 0 6.06 6.06l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                  +91 92161 83238
                </a>
              </li>
              <li>
                <a href="mailto:aqmcs@aqmcs.com" className="footer-contact-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
                  aqmcs@aqmcs.com
                </a>
              </li>
              <li>
                <span className="footer-contact-item">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                  Mon–Sat, 9 AM – 5:30 PM
                </span>
              </li>
            </ul>
          </div>

        </div>

        <hr className="footer-divider" />

        <div className="footer-bottom">
          <p>© 2006–{new Date().getFullYear()} AQMCS. All rights reserved.</p>
          <div className="footer-certs">
            {['ZED', 'ISO'].map((c) => (
              <span key={c} className="fcert">{c}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}